// extracted by mini-css-extract-plugin
export default {"body":"Header_body__gX6W7","right":"Header_right__b7qNX","left":"Header_left__rd8zR","links":"Header_links__SVFaX"};